import React, { useContext } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { List, ListItem, ListItemText, Divider, Select, MenuItem, InputLabel, FormControl, Paper } from '@mui/material'
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Unstable_Grid2'; // Grid version 2
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { useTheme } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { actualizarEvaluacion } from '../../Redux/evaluaciones';
import TokenContext from '../../context/TokenContext';

const ModalEvaluaciones = ({ open, handleClose, evaluacionPendiente, itemsEvaluacion, idEvaluacion }) => {
    const dispatch = useDispatch()
    const theme = useTheme();
    const token = useContext(TokenContext)
    const [fullWidth, setFullWidth] = React.useState(true);
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
    const [maxWidth, setMaxWidth] = React.useState('lg');
    // Verificar si vacacion es un arreglo y obtener el primer elemento
    const evaluacionData = Array.isArray(evaluacionPendiente) ? evaluacionPendiente[0] : evaluacionPendiente;
    // Destructuring
    const { id, _new_evaluado_value, new_tipodeevaluacion, _new_periodo_value, _new_materia_value, new_fechadevencimiento, _new_evaluador_value, new_evaluador, new_name } = evaluacionData || {};


    //items de evaluacion
    const [items, setItems] = React.useState([])
    const [selectedOptions, setSelectedOptions] = React.useState([]);
    const [valoracion, setValoracion] = React.useState('');

    React.useEffect(() => {
        if (itemsEvaluacion.length > 0) {
            var array = []
            itemsEvaluacion.forEach(item => {
                var objeto = {
                    new_preguntadelaevaluacionid: item.new_preguntadelaevaluacionid,
                    new_textodelapregunta: item.new_textodelapregunta,
                    new_areadecompetencia: item["_new_areadecompetencia_value@OData.Community.Display.V1.FormattedValue"],
                    _new_areadecompetencia_value: item._new_areadecompetencia_value
                }
                array.push(objeto)
            })
            setItems(array)
        } else {
            setItems([])
        }
    }, [itemsEvaluacion])

    const handleOptionChange = (id, selectValue, textFieldValue) => {
        // Validar que textFieldValue esté dentro del rango de 1 a 10
        const clampedValue = Math.min(Math.max(textFieldValue, 1), 10);

        const updatedOptions = selectedOptions.map(option => {
            if (option.new_preguntadelaevaluacionid === id) {
                return {
                    ...option,
                    new_opcionpolivalencia: selectValue,
                    new_respuesta: clampedValue
                };
            }
            return option;
        });

        const existingOption = updatedOptions.find(option => option.new_preguntadelaevaluacionid === id);
        if (!existingOption) {
            updatedOptions.push({
                new_preguntadelaevaluacionid: id,
                new_opcionpolivalencia: selectValue,
                new_respuesta: textFieldValue
            });
        }

        setSelectedOptions(updatedOptions);
    };

    //handler de la valoracion final
    const handleChange = (event) => {
        let value = event.target.value;
        value = Math.min(Math.max(parseInt(value), 1), 10);
        setValoracion(value);
    };

    const handleEnviar = () => {
        dispatch(actualizarEvaluacion(token, idEvaluacion, valoracion, selectedOptions))
    }

    return (
        <Dialog
            fullWidth={fullWidth}
            maxWidth={maxWidth}
            open={open}
            onClose={handleClose}

        >
            <DialogContent>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={12}>
                        <TextField label="Evaluación" value={new_name} fullWidth multiline />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField label="Evaluador" value={new_evaluador} fullWidth />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField label="Periodo" value={_new_periodo_value} fullWidth />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField label="Evaluado" value={_new_evaluado_value} fullWidth />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField label="Tipo de evaluación" value={new_tipodeevaluacion} fullWidth />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField label="Materia" value={_new_materia_value} fullWidth />
                    </Grid>

                    <Grid item xs={12} sm={12}>
                        <Divider />

                    </Grid>

                    <Grid item xs={12} sm={12}>
                        <Box>
                            <Paper elevation={3} sx={{ p: 4 }}>
                                <Typography variant="h6" fontWeight="bold" gutterBottom>
                                    A nivel general, mi desempeño en el ROL durante este período ha sido:
                                </Typography>
                                <Typography variant="body1" gutterBottom>
                                    Para responder, considere aspectos como:
                                </Typography>
                                <List>
                                    <ListItem>
                                        <ListItemText primary="Diseño e implementación de actividades y estrategias didácticas, para promover el aprendizaje de las/os estudiantes." />
                                    </ListItem>
                                    <ListItem>
                                        <ListItemText primary="Implementación de innovaciones en el aula con impacto en el proceso de aprendizaje de las/los estudiantes." />
                                    </ListItem>
                                    <ListItem>
                                        <ListItemText primary="Participación en actividades institucionales, del Decanatos y Carreras." />
                                    </ListItem>
                                    <ListItem>
                                        <ListItemText primary="Intervención activa en el equipo docente de la materia." />
                                    </ListItem>
                                    <ListItem>
                                        <ListItemText primary="Cumplimiento de los compromisos asociados al rol como la planificación unificada de las materias, asistencia a clases e instancias evaluativas." />
                                    </ListItem>
                                    <ListItem>
                                        <ListItemText primary="Participación en actividades de investigación, extensión, desarrollo de contenidos y promover la actividad de las/los estudiantes en las mismas." />
                                    </ListItem>
                                </List>
                            </Paper>

                        </Box>
                        <List>
                            {items.map((element) => (
                                <ListItem key={element.new_preguntadelaevaluacionid}>
                                    <Box display="flex" flexDirection="column" alignItems="flex-start" width="100%">
                                        <Typography variant="body1">{element.new_textodelapregunta}</Typography>
                                        <Box display="flex" alignItems="center" mt={2} width="100%">
                                            <FormControl fullWidth sx={{ marginRight: '10px' }}>
                                                <InputLabel id={`select-label-${element.new_preguntadelaevaluacionid}`}>Opciones</InputLabel>
                                                <Select
                                                    variant="standard"
                                                    fullWidth
                                                    labelId={`select-label-${element.new_preguntadelaevaluacionid}`}
                                                    value={(selectedOptions.find(option => option.new_preguntadelaevaluacionid === element.new_preguntadelaevaluacionid) || {}).new_opcionpolivalencia || ''}
                                                    onChange={event => handleOptionChange(element.new_preguntadelaevaluacionid, event.target.value, (selectedOptions.find(option => option.new_preguntadelaevaluacionid === element.new_preguntadelaevaluacionid) || {}).new_respuesta || '')}
                                                >
                                                    <MenuItem value={100000000}>Completamente de acuerdo</MenuItem>
                                                    <MenuItem value={100000001}>De acuerdo</MenuItem>
                                                    <MenuItem value={100000002}>Ni de acuerdo ni en desacuerdo</MenuItem>
                                                    <MenuItem value={100000003}>En desacuerdo</MenuItem>
                                                    <MenuItem value={100000004}>Completamente en desacuerdo</MenuItem>
                                                </Select>
                                            </FormControl>
                                            {/* <TextField
                                                variant="standard"
                                                label="Desempeño (1-10)"
                                                type="number"
                                                fullWidth
                                                inputProps={{ inputMode: 'numeric', pattern: '[0-9]*', min: 1, max: 10 }}
                                                value={(selectedOptions.find(option => option.new_preguntadelaevaluacionid === element.new_preguntadelaevaluacionid) || {}).new_respuesta || ''}
                                                onChange={event =>
                                                    handleOptionChange(
                                                        element.new_preguntadelaevaluacionid,
                                                        (selectedOptions.find(option => option.new_preguntadelaevaluacionid === element.new_preguntadelaevaluacionid) || {}).new_opcionpolivalencia || '',
                                                        event.target.value
                                                    )
                                                }
                                            /> */}
                                        </Box>
                                    </Box>
                                </ListItem>
                            ))}
                        </List>
                        {
                            new_tipodeevaluacion === "Coevaluación" ? null : (
                                <Box sx={{ p: 2 }}>

                                    <Typography variant="body1" sx={{ mb: 2 }}>Valoración final</Typography>
                                    <TextField
                                        label="Valoración (1-10)"
                                        type="number"
                                        fullWidth
                                        inputProps={{ inputMode: 'numeric', pattern: '[0-9]*', min: 1, max: 10 }}
                                        value={valoracion}
                                        onChange={handleChange}
                                        variant="standard"
                                    />
                                </Box>

                            )
                        }

                    </Grid>

                </Grid>

            </DialogContent>
            <DialogActions>
                <Box sx={{ p: 2, textAlign: 'right' }}>
                    <Button variant="text" color="secondary" onClick={handleClose}>
                        Cerrar
                    </Button>
                    <Button variant="contained" color="secondary" onClick={handleEnviar}>
                        Enviar
                    </Button>
                </Box>
            </DialogActions>
        </Dialog>
    )
}

export default ModalEvaluaciones